<template>
  <div id="app">
    <Header
      :section_list="section_list"
      :scrollPosition="scrollPosition"
      :user="user"
      :logged="logged"
      :id_search_category="id_search_category"
      :id_search_subcategory="id_search_subcategory"
      :search_subcategory="search_subcategory"
    />
    <CartSidebar />
    <main>
      <router-view />
    </main>
    <LoginModal />
    <WhatsappWidget />
    <ChatbotWidget
      v-if="showGlobalChatbot"
      :start-open="false"
    />
    <!-- <ConsentAgreement /> -->
    <!-- <ToTopButton /> -->
    <template v-if="configData.designFlags.isRedesignFooter">
      <RedesignFooter :section_list="section_list" />
    </template>
    <template v-else>
      <Footer :section_list="section_list" />
    </template>
    <CookiesWidget v-if="showCookieWidget" />
    <WhatsappSessionMobile />
  </div>
</template>

<script>
import {
  generateRefreshTokenBodyRequest,
  setTokens,
  getAccessToken,
} from '@/helpers/localStorage.helpers';
import data from '@/staticData.json';
import { UNAUTHORIZED } from '@/types/httpd.constants';
import WhatsappWidget from '@/components/widgets/WhatsappWidget/WhatsappWidget';
import ChatbotWidget from '@/components/widgets/ChatbotWidget/ChatbotWidget';
//import ToTopButton from '@/components/widgets/ToTopButton/ToTopButton';
import WhatsappSessionMobile from '@/components/widgets/WhatsappSessionMobile/WhatsappSessionMobile';
import CookiesWidget from '@/components/widgets/CookiesWidget/CookiesWidget';
import Header from '@/components/general/Header/Header';
import Footer from '@/components/general/Footer/Footer';
import RedesignFooter from '@/components/general/RedesignFooter/RedesignFooter';
import CartSidebar from '@/components/general/Cart/CartSidebar';
import LoginModal from '@/components/general/Modals/LoginModal.vue';
//import ConsentAgreement from '@/components/general/Modals/ConsentAgreement.vue';
import { getSections } from '@/service/sections.service';
import { postLogin, getProfileData } from '@/service/account.service';

export default {
  metaInfo: {
    title: 'Inicio',
    titleTemplate: '%s - ' + data.general.WebTitle,
  },
  components: {
    WhatsappWidget,
    ChatbotWidget,
    //ToTopButton,
    WhatsappSessionMobile,
    CookiesWidget,
    Header,
    Footer,
    RedesignFooter,
    CartSidebar,
    LoginModal,
    //ConsentAgreement,
  },
  data() {
    return {
      showCookieWidget: true,
      configData: data,
      logged: false,
      user: new Object(),
      section_list: [],
      scrollPosition: null,
      id_search_category: 0,
      id_search_subcategory: 0,
      search_subcategory: 'Todas las categorías',
    };
  },
  computed: {
    showGlobalChatbot() {
      // En /pruebaChatbot el widget vive en la página (siempre), para no duplicarlo.
      if (this.$route.name === 'pruebaChatbot') {
        return false;
      }
      return !!(this.configData.designFlags && this.configData.designFlags.isChatbotEnabled);
    },
  },
  watch: {
    $route() {
      $('#navbar1').collapse('hide');
      $('#navbar2').collapse('hide');
    },
  },

  mounted() {
    $('#myModal3').modal('show');
    window.addEventListener('scroll', this.updateScroll);
  },

  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },

    getSectionsList() {
      getSections()
        .then((response) => {
          this.section_list = response.data;
        })
        .catch((error) => {
          console.log('error aqui');
        });
    },

    refreshToken() {
      const body = generateRefreshTokenBodyRequest();
      const refreshingCall = postLogin(body).then((response) => {
        setTokens(response.data.access_token, response.data.refresh_token);
        return Promise.resolve(true);
      });
      return refreshingCall;
    },

    callUserInformation() {
      getProfileData(getAccessToken())
        .then((response) => {
          this.user = response.data;
          this.logged = true;
        })
        .catch((error) => {
          if (error.response.status === UNAUTHORIZED) {
            this.refreshToken()
              .then((_) => {
                this.callUserInformation();
              })
              .catch((_) => {
                this.logged = false;
              });
          }
          this.logged = false;
        });
    },

    setSearch_category(value) {
      this.search_subcategory = value.product_type_desc_es;
      this.id_search_subcategory = 0;
      this.c = value.id_category;
      this.$router.push('/productos/0/1/' + value.id_category + '/0/0/0');
    },

    setSearch_subcategory_toSeccion(subcategory_id, subcategory_description, section) {
      this.search_subcategory = subcategory_description;
      this.id_search_category = 0;
      this.id_search_subcategory = subcategory_id;
      this.$router.push({ name: section });
    },

    setSearch_subcategory(subcategory_id, subcategory_description, idcategoria) {
      this.search_subcategory = subcategory_description;
      this.id_search_category = idcategoria;
      this.id_search_subcategory = subcategory_id;
      if (idcategoria == 0) {
        this.$router.push({ name: 'productos' });
      } else {
        this.$router.push(
          '/productos/0/1/' + idcategoria + '/' + this.id_search_subcategory + '/0/0',
        );
      }
    },

    closeCookieWidget() {
      this.showCookieWidget = false;
    },
  },

  created() {
    this.callUserInformation();
    this.getSectionsList();
  },
};
</script>

<style lang="scss" src="./assets/css/global.scss"></style>
